"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var FontIcon_1 = __importDefault(require("../icon/FontIcon"));
var tooltip_1 = __importDefault(require("../tooltip"));
var classnames_1 = __importDefault(require("classnames"));
var interfaces_1 = require("./interfaces");
var LabelTooltipDecoratorHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var LabelTooltipDecoratorTooltip = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  margin-left: auto;\n  font-size: 16px;\n"], ["\n  display: inline-block;\n  margin-left: auto;\n  font-size: 16px;\n"])));
var LabelTooltipDecorator = function (_a) {
    var id = _a.id, htmlFor = _a.htmlFor, label = _a.label, placement = _a.placement, tooltip = _a.tooltip, tooltipCloseLabel = _a.tooltipCloseLabel, showRequired = _a.showRequired;
    var _b = __read(react_1.useState(false), 2), showTooltip = _b[0], setShowTooltip = _b[1];
    var classes = classnames_1.default('tk-label', {
        'tk-label--required': showRequired,
    });
    return label || tooltip ? (React.createElement(LabelTooltipDecoratorHeader, { className: "tk-input-group__header" },
        label ? (React.createElement("label", { className: classes, htmlFor: htmlFor }, label)) : null,
        tooltip ? (React.createElement(LabelTooltipDecoratorTooltip, null,
            React.createElement(tooltip_1.default, { id: id, description: tooltip, closeLabel: tooltipCloseLabel, onHintClose: function () { return setShowTooltip(false); }, visible: showTooltip, placement: placement || 'top' },
                React.createElement(FontIcon_1.default, { className: "tk-input-group__hint", iconName: "info-round", onClick: function () { return setShowTooltip(!showTooltip); }, onKeyDown: function (event) { return (event.key === 'Enter') && setShowTooltip(!showTooltip); }, tabIndex: 0 })))) : null)) : null;
};
LabelTooltipDecorator.propTypes = __assign({}, interfaces_1.LabelTooltipDecoratorPropTypes);
exports.default = LabelTooltipDecorator;
var templateObject_1, templateObject_2;
